import React, { useState } from 'react'
import './OperatProf.css'
import { IMG_SERVER_URL } from '../../../ServerUrl'
import OperatorPicturesSlider from './OperatorPicturesSlider'



const OperatorPictureSection = ({ operator }) => {
    return (
        <div className='picSectOuter'>
            <div className='pictursText'>{operator?.companyname}s Picture Gallery:</div>
            <OperatorPicturesSlider operator={operator} />
        </div>

    )
}

export default OperatorPictureSection
